import produce from 'immer';
import { ReducerAction } from 'store/modules/types';
import { Types, cancelarAutorizacaoPrevia } from './types';

export const INITIAL_STATE: cancelarAutorizacaoPrevia = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): cancelarAutorizacaoPrevia {
	return produce(state, draft => {
		switch (action.type) {
			case Types.CANCELAR_AUTORIZACAO_PREVIA_REQUEST: {
				break;
			}

			case Types.CANCELAR_AUTORIZACAO_PREVIA_SUCCESS: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}

			case Types.CANCELAR_AUTORIZACAO_PREVIA_FAILURE: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}
			case Types.CANCELAR_AUTORIZACAO_PREVIA_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
		return draft;
	});
}
